import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
// import 'react-typed/dist/animatedCursor.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// import Col from 'react-bootstrap';
// import Row from 'react-bootstrap';

class Software extends Component {
    render() {
        const { title, programs } = this.props.data;
        AOS.init();
        const getPath = name => {
            switch (name) {
                case 'c':
                    return (
                        <>
                            <g id='Layer_1'></g>
                            <g id='Layer_2'></g>
                            <g id='Layer_3'>
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#283593',
                                    }}
                                    d='M22.903,3.286c0.679-0.381,1.515-0.381,2.193,0   c3.355,1.883,13.451,7.551,16.807,9.434C42.582,13.1,43,13.804,43,14.566c0,3.766,0,15.101,0,18.867   c0,0.762-0.418,1.466-1.097,1.847c-3.355,1.883-13.451,7.551-16.807,9.434c-0.679,0.381-1.515,0.381-2.193,0   c-3.355-1.883-13.451-7.551-16.807-9.434C5.418,34.899,5,34.196,5,33.434c0-3.766,0-15.101,0-18.867   c0-0.762,0.418-1.466,1.097-1.847C9.451,10.837,19.549,5.169,22.903,3.286z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#5C6BC0',
                                    }}
                                    d='M5.304,34.404C5.038,34.048,5,33.71,5,33.255   c0-3.744,0-15.014,0-18.759c0-0.758,0.417-1.458,1.094-1.836c3.343-1.872,13.405-7.507,16.748-9.38   c0.677-0.379,1.594-0.371,2.271,0.008c3.343,1.872,13.371,7.459,16.714,9.331c0.27,0.152,0.476,0.335,0.66,0.576L5.304,34.404z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    d='M24,10c7.727,0,14,6.273,14,14s-6.273,14-14,14   s-14-6.273-14-14S16.273,10,24,10z M24,17c3.863,0,7,3.136,7,7c0,3.863-3.137,7-7,7s-7-3.137-7-7C17,20.136,20.136,17,24,17z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#3949AB',
                                    }}
                                    d='M42.485,13.205c0.516,0.483,0.506,1.211,0.506,1.784   c0,3.795-0.032,14.589,0.009,18.384c0.004,0.396-0.127,0.813-0.323,1.127L23.593,24L42.485,13.205z'
                                />
                            </g>
                        </>
                    );
                case 'c++':
                    return (
                        <>
                            <g id='Layer_1'></g>
                            <g id='Layer_2'></g>
                            <g id='Layer_3'>
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#00549D',
                                    }}
                                    d='M22.903,3.286c0.679-0.381,1.515-0.381,2.193,0   c3.355,1.883,13.451,7.551,16.807,9.434C42.582,13.1,43,13.804,43,14.566c0,3.766,0,15.101,0,18.867   c0,0.762-0.418,1.466-1.097,1.847c-3.355,1.883-13.451,7.551-16.807,9.434c-0.679,0.381-1.515,0.381-2.193,0   c-3.355-1.883-13.451-7.551-16.807-9.434C5.418,34.899,5,34.196,5,33.434c0-3.766,0-15.101,0-18.867   c0-0.762,0.418-1.466,1.097-1.847C9.451,10.837,19.549,5.169,22.903,3.286z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#0086D4',
                                    }}
                                    d='M5.304,34.404C5.038,34.048,5,33.71,5,33.255   c0-3.744,0-15.014,0-18.759c0-0.758,0.417-1.458,1.094-1.836c3.343-1.872,13.405-7.507,16.748-9.38   c0.677-0.379,1.594-0.371,2.271,0.008c3.343,1.872,13.371,7.459,16.714,9.331c0.27,0.152,0.476,0.335,0.66,0.576L5.304,34.404z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    d='M24,10c7.727,0,14,6.273,14,14s-6.273,14-14,14   s-14-6.273-14-14S16.273,10,24,10z M24,17c3.863,0,7,3.136,7,7c0,3.863-3.137,7-7,7s-7-3.137-7-7C17,20.136,20.136,17,24,17z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#0075C0',
                                    }}
                                    d='M42.485,13.205c0.516,0.483,0.506,1.211,0.506,1.784   c0,3.795-0.032,14.589,0.009,18.384c0.004,0.396-0.127,0.813-0.323,1.127L23.593,24L42.485,13.205z'
                                />
                                <rect
                                    x='31'
                                    y='21'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='2'
                                    height='6'
                                />
                                <rect
                                    x='38'
                                    y='21'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='2'
                                    height='6'
                                />
                                <rect
                                    x='29'
                                    y='23'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='6'
                                    height='2'
                                />
                                <rect
                                    x='36'
                                    y='23'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='6'
                                    height='2'
                                />
                            </g>
                        </>
                    );
                case 'csharp':
                    return (
                        <>
                            <g id='Layer_1'></g>
                            <g id='Layer_2'></g>
                            <g id='Layer_3'>
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#37474F',
                                    }}
                                    d='M22.903,3.286c0.679-0.381,1.515-0.381,2.193,0   c3.355,1.883,13.451,7.551,16.807,9.434C42.582,13.1,43,13.804,43,14.566c0,3.766,0,15.101,0,18.867   c0,0.762-0.418,1.466-1.097,1.847c-3.355,1.883-13.451,7.551-16.807,9.434c-0.679,0.381-1.515,0.381-2.193,0   c-3.355-1.883-13.451-7.551-16.807-9.434C5.418,34.899,5,34.196,5,33.434c0-3.766,0-15.101,0-18.867   c0-0.762,0.418-1.466,1.097-1.847C9.451,10.837,19.549,5.169,22.903,3.286z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#546E7A',
                                    }}
                                    d='M5.304,34.404C5.038,34.048,5,33.71,5,33.255   c0-3.744,0-15.014,0-18.759c0-0.758,0.417-1.458,1.094-1.836c3.343-1.872,13.405-7.507,16.748-9.38   c0.677-0.379,1.594-0.371,2.271,0.008c3.343,1.872,13.371,7.459,16.714,9.331c0.27,0.152,0.476,0.335,0.66,0.576L5.304,34.404z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    d='M24,10c7.727,0,14,6.273,14,14s-6.273,14-14,14   s-14-6.273-14-14S16.273,10,24,10z M24,17c3.863,0,7,3.136,7,7c0,3.863-3.137,7-7,7s-7-3.137-7-7C17,20.136,20.136,17,24,17z'
                                />
                                <path
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#455A64',
                                    }}
                                    d='M42.485,13.205c0.516,0.483,0.506,1.211,0.506,1.784   c0,3.795-0.032,14.589,0.009,18.384c0.004,0.396-0.127,0.813-0.323,1.127L23.593,24L42.485,13.205z'
                                />
                                <rect
                                    x='34'
                                    y='20'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='1'
                                    height='8'
                                />
                                <rect
                                    x='37'
                                    y='20'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='1'
                                    height='8'
                                />
                                <rect
                                    x='32'
                                    y='25'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='8'
                                    height='1'
                                />
                                <rect
                                    x='32'
                                    y='22'
                                    style={{
                                        fillRule: 'evenodd',
                                        clipRule: 'evenodd',
                                        fill: '#FFFFFF',
                                    }}
                                    width='8'
                                    height='1'
                                />
                            </g>
                        </>
                    );
                case 'java':
                    return (
                        <>
                            <g>
                                <path
                                    fill='#F44336'
                                    d='M23.65,24.898c-0.998-1.609-1.722-2.943-2.725-5.455C19.229,15.2,31.24,11.366,26.37,3.999
                            c2.111,5.089-7.577,8.235-8.477,12.473C17.07,20.37,23.645,24.898,23.65,24.898z'
                                />
                                <path
                                    fill='#F44336'
                                    d='M23.878,17.27c-0.192,2.516,2.229,3.857,2.299,5.695c0.056,1.496-1.447,2.743-1.447,2.743
                            s2.728-0.536,3.579-2.818c0.945-2.534-1.834-4.269-1.548-6.298c0.267-1.938,6.031-5.543,6.031-5.543S24.311,11.611,23.878,17.27z'
                                />
                            </g>
                            <g>
                                <path
                                    fill='#1565C0'
                                    d='M32.084,25.055c1.754-0.394,3.233,0.723,3.233,2.01c0,2.901-4.021,5.643-4.021,5.643
                            s6.225-0.742,6.225-5.505C37.521,24.053,34.464,23.266,32.084,25.055z'
                                />
                                <path
                                    fill='#1565C0'
                                    d='M29.129,27.395c0,0,1.941-1.383,2.458-1.902c-4.763,1.011-15.638,1.147-15.638,0.269
                            c0-0.809,3.507-1.638,3.507-1.638s-7.773-0.112-7.773,2.181C11.683,28.695,21.858,28.866,29.129,27.395z'
                                />
                                <path
                                    fill='#1565C0'
                                    d='M27.935,29.571c-4.509,1.499-12.814,1.02-10.354-0.993c-1.198,0-2.974,0.963-2.974,1.889
                            c0,1.857,8.982,3.291,15.63,0.572L27.935,29.571z'
                                />
                                <path
                                    fill='#1565C0'
                                    d='M18.686,32.739c-1.636,0-2.695,1.054-2.695,1.822c0,2.391,9.76,2.632,13.627,0.205l-2.458-1.632
                            C24.271,34.404,17.014,34.579,18.686,32.739z'
                                />
                                <path
                                    fill='#1565C0'
                                    d='M36.281,36.632c0-0.936-1.055-1.377-1.433-1.588c2.228,5.373-22.317,4.956-22.317,1.784
                            c0-0.721,1.807-1.427,3.477-1.093l-1.42-0.839C11.26,34.374,9,35.837,9,37.017C9,42.52,36.281,42.255,36.281,36.632z'
                                />
                                <path
                                    fill='#1565C0'
                                    d='M39,38.604c-4.146,4.095-14.659,5.587-25.231,3.057C24.341,46.164,38.95,43.628,39,38.604z'
                                />
                            </g>
                        </>
                    );
                case 'javascript':
                    return (
                        <path
                            fill='#4C6EF5'
                            d='M43.334,4H6.667C5.196,4,4,5.196,4,6.667v36.666C4,44.804,5.196,46,6.667,46h36.666C44.804,46,46,44.804,46,43.334V6.667 C46,5.196,44.804,4,43.334,4z M27,36.182C27,40.18,24.656,42,21.234,42c-3.092,0-5.324-2.073-6.234-4l3.143-1.903 C18.75,37.173,19.673,38,21,38c1.269,0,2-0.496,2-2.426V23h4V36.182z M35.677,42c-3.544,0-5.557-1.787-6.677-4l3-2 c0.818,1.335,1.707,2.614,3.589,2.614c1.581,0,2.411-0.79,2.411-1.882c0-1.308-0.858-1.772-2.598-2.533l-0.954-0.409 c-2.753-1.173-4.583-2.643-4.583-5.749c0-2.862,2.18-5.04,5.588-5.04c2.426,0,4.17,0.844,5.427,3.055l-2.971,1.908 c-0.654-1.173-1.36-1.635-2.456-1.635c-1.118,0-1.826,0.709-1.826,1.635c0,1.145,0.709,1.608,2.346,2.317l0.954,0.409 C40.17,32.079,42,33.496,42,36.683C42,40.118,39.301,42,35.677,42z'
                        />
                    );
                case 'react':
                    return (
                        <path
                            fill='#00D8FF'
                            d='M12 9.861A2.139 2.139 0 1 0 12 14.139 2.139 2.139 0 1 0 12 9.861zM6.008 16.255l-.472-.12C2.018 15.246 0 13.737 0 11.996s2.018-3.25 5.536-4.139l.472-.119.133.468a23.53 23.53 0 0 0 1.363 3.578l.101.213-.101.213a23.307 23.307 0 0 0-1.363 3.578l-.133.467zM5.317 8.95c-2.674.751-4.315 1.9-4.315 3.046 0 1.145 1.641 2.294 4.315 3.046a24.95 24.95 0 0 1 1.182-3.046A24.752 24.752 0 0 1 5.317 8.95zM17.992 16.255l-.133-.469a23.357 23.357 0 0 0-1.364-3.577l-.101-.213.101-.213a23.42 23.42 0 0 0 1.364-3.578l.133-.468.473.119c3.517.889 5.535 2.398 5.535 4.14s-2.018 3.25-5.535 4.139l-.473.12zm-.491-4.259c.48 1.039.877 2.06 1.182 3.046 2.675-.752 4.315-1.901 4.315-3.046 0-1.146-1.641-2.294-4.315-3.046a24.788 24.788 0 0 1-1.182 3.046zM5.31 8.945l-.133-.467C4.188 4.992 4.488 2.494 6 1.622c1.483-.856 3.864.155 6.359 2.716l.34.349-.34.349a23.552 23.552 0 0 0-2.422 2.967l-.135.193-.235.02a23.657 23.657 0 0 0-3.785.61l-.472.119zm1.896-6.63c-.268 0-.505.058-.705.173-.994.573-1.17 2.565-.485 5.253a25.122 25.122 0 0 1 3.233-.501 24.847 24.847 0 0 1 2.052-2.544c-1.56-1.519-3.037-2.381-4.095-2.381zM16.795 22.677c-.001 0-.001 0 0 0-1.425 0-3.255-1.073-5.154-3.023l-.34-.349.34-.349a23.53 23.53 0 0 0 2.421-2.968l.135-.193.234-.02a23.63 23.63 0 0 0 3.787-.609l.472-.119.134.468c.987 3.484.688 5.983-.824 6.854a2.38 2.38 0 0 1-1.205.308zm-4.096-3.381c1.56 1.519 3.037 2.381 4.095 2.381h.001c.267 0 .505-.058.704-.173.994-.573 1.171-2.566.485-5.254a25.02 25.02 0 0 1-3.234.501 24.674 24.674 0 0 1-2.051 2.545zM18.69 8.945l-.472-.119a23.479 23.479 0 0 0-3.787-.61l-.234-.02-.135-.193a23.414 23.414 0 0 0-2.421-2.967l-.34-.349.34-.349C14.135 1.778 16.515.767 18 1.622c1.512.872 1.812 3.37.824 6.855l-.134.468zM14.75 7.24c1.142.104 2.227.273 3.234.501.686-2.688.509-4.68-.485-5.253-.988-.571-2.845.304-4.8 2.208A24.849 24.849 0 0 1 14.75 7.24zM7.206 22.677A2.38 2.38 0 0 1 6 22.369c-1.512-.871-1.812-3.369-.823-6.854l.132-.468.472.119c1.155.291 2.429.496 3.785.609l.235.02.134.193a23.596 23.596 0 0 0 2.422 2.968l.34.349-.34.349c-1.898 1.95-3.728 3.023-5.151 3.023zm-1.19-6.427c-.686 2.688-.509 4.681.485 5.254.987.563 2.843-.305 4.8-2.208a24.998 24.998 0 0 1-2.052-2.545 24.976 24.976 0 0 1-3.233-.501zM12 16.878c-.823 0-1.669-.036-2.516-.106l-.235-.02-.135-.193a30.388 30.388 0 0 1-1.35-2.122 30.354 30.354 0 0 1-1.166-2.228l-.1-.213.1-.213a30.3 30.3 0 0 1 1.166-2.228c.414-.716.869-1.43 1.35-2.122l.135-.193.235-.02a29.785 29.785 0 0 1 5.033 0l.234.02.134.193a30.006 30.006 0 0 1 2.517 4.35l.101.213-.101.213a29.6 29.6 0 0 1-2.517 4.35l-.134.193-.234.02c-.847.07-1.694.106-2.517.106zm-2.197-1.084c1.48.111 2.914.111 4.395 0a29.006 29.006 0 0 0 2.196-3.798 28.585 28.585 0 0 0-2.197-3.798 29.031 29.031 0 0 0-4.394 0 28.477 28.477 0 0 0-2.197 3.798 29.114 29.114 0 0 0 2.197 3.798z'
                        />
                    );
                case 'puppeteer':
                    return (
                        <>
                            <path
                                d='M253.422 214.246H2.192v-14.168c0-9.52 7.717-17.237 17.236-17.237h216.757c9.52 0 17.237 7.717 17.237 17.237v14.168z'
                                fill='#DFDEDF'
                            />
                            <path
                                d='M235.92 378.553H19.692c-9.666 0-17.502-7.836-17.502-17.502V214.246h251.23V361.05c0 9.666-7.835 17.502-17.502 17.502'
                                fill='#FFF'
                            />
                            <path
                                d='M250.302 211.398v-12.706c0-7.501-6.08-13.582-13.581-13.582H19.279c-7.501 0-13.581 6.08-13.581 13.582v12.706h244.604zm0 151.469V217.096H5.698v145.77c0 7.502 6.08 13.582 13.581 13.582h217.442c7.501 0 13.581-6.08 13.581-13.581zM20.554 179.413l.846-9.236l-3.592 9.31c.487-.037.974-.074 1.471-.074h1.275zm213.401-15.57l1.254 15.57h1.512c.809 0 1.601.066 2.384.163l-5.15-15.733zm17.247 22.164c2.977 3.394 4.798 7.826 4.798 12.685v164.175c0 10.63-8.649 19.279-19.279 19.279H19.279C8.649 382.146 0 373.498 0 362.866V198.693c0-5.152 2.043-9.827 5.347-13.29l19.22-49.817l8.381-91.554l9.456.865l-7.552 82.492l2.66 1.026l-3.61 9.358l-3.812 41.64h195.593L214.829 44.669l9.464-.763l6.402 79.469l.004-.001l20.503 62.634zm-230.046 8.39a4.302 4.302 0 1 1 0 8.603a4.302 4.302 0 0 1 0-8.603zm14.709 0a4.302 4.302 0 1 1 0 8.603a4.302 4.302 0 0 1 0-8.603zm14.244 0a4.302 4.302 0 1 1 0 8.603a4.302 4.302 0 0 1 0-8.603z'
                                fill='#000'
                            />
                            <path
                                d='M36.022 287.748c.739-.855 1.128-1.979 1.128-3.374c0-1.396-.39-2.475-1.128-3.33c-.778-.855-1.868-1.26-3.268-1.26h-6.847v9.223h6.847c1.4 0 2.49-.405 3.268-1.259zm-3.268-13.497c2.956 0 5.29.9 7.04 2.744c1.752 1.844 2.608 4.318 2.608 7.38c0 3.102-.856 5.532-2.567 7.376c-1.751 1.846-4.085 2.79-7.081 2.79h-6.847v12.414h-5.291v-32.704h12.138zm28.544 20.057v-9.54h5.698v21.54h-5.698v-1.942c-1.727 1.726-3.97 2.589-6.777 2.589c-2.59 0-4.662-.863-6.259-2.546c-1.597-1.683-2.374-3.842-2.374-6.518v-13.123h5.698v11.914c0 1.51.388 2.763 1.208 3.67c.777.906 1.813 1.38 3.151 1.38c3.583 0 5.353-2.46 5.353-7.424zm27.926 5.914c1.122-1.166 1.683-2.72 1.683-4.662c0-1.942-.56-3.54-1.683-4.705c-1.166-1.166-2.59-1.77-4.36-1.77c-1.597 0-3.02.604-4.273 1.813c-1.252 1.209-1.856 2.762-1.856 4.662c0 1.899.604 3.454 1.856 4.618c1.252 1.21 2.676 1.814 4.273 1.814c1.77 0 3.194-.604 4.36-1.77zm-3.367-16.101c2.806 0 5.31 1.08 7.425 3.238c2.115 2.2 3.15 4.92 3.15 8.2c0 3.28-1.035 6-3.15 8.159c-2.116 2.159-4.576 3.237-7.425 3.237c-2.806 0-5.18-.777-7.122-2.33v11.959h-5.698v-31.816h5.698v1.727c1.9-1.597 4.273-2.374 7.122-2.374zm31.078 16.1c1.122-1.165 1.683-2.72 1.683-4.661c0-1.942-.561-3.54-1.683-4.705c-1.166-1.166-2.59-1.77-4.36-1.77c-1.597 0-3.021.604-4.273 1.813c-1.252 1.209-1.857 2.762-1.857 4.662c0 1.899.605 3.454 1.857 4.618c1.252 1.21 2.676 1.814 4.273 1.814c1.77 0 3.194-.604 4.36-1.77zm-3.368-16.1c2.806 0 5.31 1.08 7.426 3.238c2.114 2.2 3.15 4.92 3.15 8.2c0 3.28-1.036 6-3.15 8.159c-2.116 2.159-4.576 3.237-7.426 3.237c-2.805 0-5.18-.777-7.122-2.33v11.959h-5.697v-31.816h5.697v1.727c1.9-1.597 4.274-2.374 7.122-2.374zm18.991 8.935h10.403c-.345-1.338-.993-2.33-1.899-2.98c-.907-.646-1.985-.991-3.195-.991a5.684 5.684 0 0 0-3.28 1.036c-1.036.69-1.727 1.683-2.029 2.935zm5.31-8.935c2.935 0 5.482 1.036 7.597 3.065c2.115 2.072 3.194 4.704 3.324 7.942v1.943h-16.403c.302 1.51.95 2.718 1.943 3.626c.992.906 2.114 1.38 3.452 1.38c2.461 0 4.231-.95 5.353-2.848l5.094 1.079c-.907 2.202-2.288 3.843-4.1 4.965c-1.814 1.122-3.929 1.682-6.347 1.682c-3.108 0-5.74-1.078-7.856-3.193c-2.115-2.115-3.195-4.878-3.195-8.202c0-3.323 1.08-6.086 3.238-8.245c2.115-2.114 4.75-3.194 7.9-3.194zm26.632 17.526c1.079 0 2.288-.346 3.583-1.036l1.64 4.748c-1.986 1.079-3.842 1.597-5.612 1.597c-2.633 0-4.705-.734-6.216-2.16c-1.51-1.422-2.244-3.538-2.244-6.43v-8.936h-4.62v-4.662h4.62v-6.517h5.698v6.517h7.036v4.662h-7.036v8.504c0 2.46 1.036 3.713 3.15 3.713zm11.954-8.591h10.403c-.345-1.338-.993-2.33-1.899-2.98c-.907-.646-1.985-.991-3.195-.991a5.684 5.684 0 0 0-3.28 1.036c-1.036.69-1.727 1.683-2.029 2.935zm5.31-8.935c2.935 0 5.482 1.036 7.597 3.065c2.115 2.072 3.194 4.704 3.324 7.942v1.943h-16.403c.302 1.51.95 2.718 1.943 3.626c.992.906 2.114 1.38 3.452 1.38c2.461 0 4.231-.95 5.353-2.848l5.093 1.079c-.906 2.202-2.287 3.843-4.1 4.965c-1.813 1.122-3.928 1.682-6.346 1.682c-3.108 0-5.74-1.078-7.856-3.193c-2.115-2.115-3.195-4.878-3.195-8.202c0-3.323 1.08-6.086 3.238-8.245c2.115-2.114 4.75-3.194 7.9-3.194zm20.285 8.935h10.403c-.345-1.338-.993-2.33-1.898-2.98c-.907-.646-1.986-.991-3.196-.991a5.684 5.684 0 0 0-3.28 1.036c-1.036.69-1.727 1.683-2.029 2.935zm5.31-8.935c2.935 0 5.482 1.036 7.597 3.065c2.115 2.072 3.195 4.704 3.325 7.942v1.943h-16.404c.302 1.51.95 2.718 1.944 3.626c.992.906 2.114 1.38 3.452 1.38c2.46 0 4.23-.95 5.352-2.848l5.095 1.079c-.907 2.202-2.288 3.843-4.101 4.965c-1.814 1.122-3.929 1.682-6.346 1.682c-3.108 0-5.742-1.078-7.856-3.193c-2.115-2.115-3.196-4.878-3.196-8.202c0-3.323 1.08-6.086 3.238-8.245c2.115-2.114 4.75-3.194 7.9-3.194zm28.66.345c.649 0 1.167.043 1.513.172l-.303 5.483h-1.251c-5.137 0-7.685 3.065-7.685 9.238v6.949h-5.697v-21.54h5.697v3.928c1.943-2.806 4.533-4.23 7.727-4.23z'
                                fill='#000'
                            />
                            <path
                                fill='#00D8A2'
                                d='M211.095 132.638l30.741-14.84v-14.84l-71.023-33.923l71.023-36.57v-14.31l-29.68-13.782l-84.097 41.871l-85.51-41.87l-27.56 14.84v12.72L81.77 68.505l-66.782 33.922v15.37l28.621 14.841l84.803-43.462z'
                            />
                            <path
                                d='M214.95 126.585v-6.392l23.14-11.991v7.18l-23.14 11.203zm-198.1-18.551l22.36 12.836v5.11l-22.36-11.312v-6.634zM131.383 81.04l76.92 38.005v7.642l-76.92-39.405V81.04zm-85.526 39.117l78.88-39.11v6.233l-78.88 39.908v-7.031zm55.852-63.905L21.887 17.714L42.561 7.207L128.06 51.53l84.067-44.304l21.404 10.963l-77.84 39.174c-3.113 1.566-3.108 6.01.007 7.57l77.038 38.557l-19.968 10.347l-84.708-43.403l-86.206 44.289l-19.689-11.303l79.59-39.562c3.152-1.567 3.126-6.075-.045-7.606zM17.844 30.77v-7.014L92.29 60.899l-7.526 3.007l-66.92-33.135zm152.654 33.548c-.102-.062-7.13-3.378-7.13-3.378l74.721-37.605v7.045L170.5 64.319zm7.48 3.683l65.674-32.976a1.969 1.969 0 0 0 1.085-1.76V17.665a1.97 1.97 0 0 0-1.07-1.752L213.032.222a1.97 1.97 0 0 0-1.788-.003l-82.303 41.764a1.965 1.965 0 0 1-1.769.006L43.42.207a1.97 1.97 0 0 0-1.77.007L11.28 15.648a1.969 1.969 0 0 0-1.078 1.755v15.855c0 .749.425 1.433 1.097 1.765L77.25 67.607l-65.646 32.595a1.968 1.968 0 0 0-1.092 1.727l-.287 15.59a1.969 1.969 0 0 0 1.08 1.793l31.536 15.956a1.97 1.97 0 0 0 1.772.002l82.558-41.455a1.968 1.968 0 0 1 1.775.004l81.53 41.454a1.97 1.97 0 0 0 1.748.017l31.402-15.203a1.969 1.969 0 0 0 1.111-1.771v-16.29c0-.751-.427-1.436-1.1-1.767l-65.66-32.257z'
                                fill='#000'
                            />
                        </>
                    );
                case 'systemverilog':
                    return (
                        <>
                            <path
                                fill='#000000'
                                d='M19.316,366.6029968V149.8329926c0-12.0299988,9.7520008-21.7810059,21.7810001-21.7810059h429.8049927c12.0289917,0,21.7810059,9.7519989,21.7810059,21.7810059v216.7700043c0,12.0289917-9.7520142,21.7810059-21.7810059,21.7810059H41.0969849c-12.0289993,0-21.7819996-9.7520142-21.7819996-21.7810059H19.316z M455.9639893,119.7019958V70.7910004h-68.9570007v48.9109955H455.9639893z M387.0069885,398.1099854v43.8439941h68.9570007v-43.8439941H387.0069885z M440.4620056,61.1169968L436.1180115,0h-28.519989l-5.0889893,61.1169968h37.95401H440.4620056z M402.5090027,450.8840027L407.5979919,512h28.519989l4.3439941-61.1159973h-37.95401H402.5090027z M346.6929932,119.7019958V70.7910004h-68.9570007v48.9109955H346.6929932z M277.7359924,398.1099854v43.8439941h68.9570007v-43.8439941H277.7359924z M331.1919861,61.1169968L326.8479919,0h-28.519989l-5.0889893,61.1169968h37.95401H331.1919861z M293.2380066,450.8840027L298.3269958,512h28.519989l4.3439941-61.1159973h-37.95401H293.2380066z M237.4219971,119.7019958V70.7910004h-68.9570007v48.9109955H237.4219971z M168.4649963,398.1099854v43.8439941h68.9570007v-43.8439941H168.4649963z M221.9210052,61.1169968L217.576004,0h-28.5200043l-5.0890045,61.1169968h37.9530029H221.9210052z M183.9669952,450.8840027L189.0559998,512h28.5200043l4.3450012-61.1159973h-37.9530029H183.9669952z M128.151001,119.7019958V70.7910004H59.1940002v48.9109955H128.151001z M59.1940002,398.1099854v43.8439941h68.9570007v-43.8439941H59.1940002z M112.6500015,61.1169968L108.3059998,0H79.7859955l-5.0889969,61.1169968h37.9540024H112.6500015z M74.6959991,450.8840027L79.784996,512h28.5199966l4.3440018-61.1159973H74.6959991z M390.3914185,301.1523743c-61.5627441,69.6324463-250.3877869,63.6724854-286.0517273-16.5291443H64.4300537C92.8762894,389.0718689,332.6317749,393.3719482,390.3914185,301.1523743z M447.5699463,230.501709c-28.4461975-104.4486542-268.2017212-108.748848-325.9614258-16.5293121c61.5627899-69.6324005,250.3878479-63.6723633,286.0517578,16.5292969L447.5699463,230.501709z M170.909668,281.8242188c0.6401367,0,1.1201172,0.1591797,1.1201172,1.2792969c0.3198242,4.9599609,2.5600586,11.8408203,6.4003906,18.0810547c4.6396484,7.359375,12.4799805,10.8798828,20.1601562,10.8798828s20.0004883-5.1201172,20.0004883-17.7607422c0-13.2802734-2.5600586-17.1201172-23.3603516-24.9609375c-4.800293-1.7597656-15.0405273-6.8798828-23.2006836-13.9194336c-5.6000977-4.9604492-8-13.4404297-8-22.7207031c0-9.7602539,2.3999023-16.3203125,12-23.5205078c7.2001953-5.4399414,13.2802734-7.6801758,23.0405273-7.6801758c11.6801758,0,17.9204102,1.9199219,21.2807617,3.2001953c1.5996094,0.6396484,2.7197266,0.3198242,3.6796875-0.800293l2.0800781-2.0800781c0.6401367-0.6396484,1.4404297-0.9599609,2.4003906-0.9599609c1.1201172,0,1.4399414,1.7602539,1.6000977,2.7202148l2.5600586,27.3603516c0,0.6401367-0.3203125,0.800293-0.800293,0.9604492l-3.5200195,1.1196289c-0.7998047,0.3203125-1.6000977,0-2.0800781-1.1196289c-1.7597656-4.6401367-4.4799805-10.8803711-9.9204102-16.640625c-4-4.4799805-8.7998047-6.7202148-16-6.7202148c-12.0004883,0-16.9604492,10.4003906-16.9604492,14.5605469c0,5.9199219,0.1601562,10.7202148,4.1601562,14.7202148c4.1601562,4.3203125,13.2802734,8.1601562,21.1201172,10.4003906c7.6801758,2.2397461,13.9204102,6.2397461,20.4804688,12.159668c6.2402344,5.6005859,8.800293,12.640625,8.800293,23.8408203c0,19.5205078-13.9204102,35.3613281-35.0405273,35.3613281c-14.4003906,0-21.9208984-2.4003906-28.640625-6.8808594c-1.9204102-1.2792969-2.8803711-1.7597656-3.6801758-1.7597656c-0.9599609,0-1.6000977,1.1201172-2.5600586,2.7197266c-0.9599609,1.7607422-1.7602539,1.9208984-2.8803711,1.9208984c-1.7597656,0-2.3999023-0.8007812-2.2397461-2.5605469l2.5600586-30.4003906c0.159668-1.1201172,0.6401367-1.1201172,1.2797852-1.1201172L170.909668,281.8242188z M323.7578125,204.5419922c0-0.7998047,0.1601562-1.1201172,0.9599609-1.1201172c1.4404297,0,8.7998047,0.4799805,19.5205078,0.4799805c14.8808594,0,18.8808594-0.4799805,20.3203125-0.4799805c0.9599609,0,1.1201172,0.3203125,1.1201172,1.4399414v4.0004883c0,0.6396484-0.1601562,1.1196289-1.1201172,1.1196289h-3.6796875c-2.7207031,0-7.6806641,1.1201172-11.8408203,8.3203125c-6.4003906,10.8803711-13.2802734,29.7607422-19.3603516,43.2006836c-4,8.640625-22.0800781,51.5214844-24.8007812,56.1621094c-1.1201172,1.9199219-1.9199219,2.7197266-3.6796875,2.7197266c-2.0800781,0-2.7197266-1.9199219-3.6806641-4c-5.9199219-12.640625-20.4804688-51.3613281-24.9599609-62.4018555c-4.4804688-11.0400391-12.4804688-34.2407227-14.4003906-38.7207031c-1.6005859-3.6801758-3.5205078-5.2802734-6.8803711-5.2802734h-4.1601562c-0.6401367,0-0.800293-0.7998047-0.800293-1.6000977v-3.8398438c0-0.7998047,0.1601562-1.1201172,1.1201172-1.1201172c1.6000977,0,6.8803711,0.4799805,26.0810547,0.4799805c16.640625,0,23.8408203-0.4799805,25.2802734-0.4799805c1.4404297,0,1.6005859,0.4799805,1.6005859,1.4399414v3.6801758c0,0.800293-0.1601562,1.4399414-1.2802734,1.4399414h-6.8798828c-3.8408203,0-6.8808594,1.7602539-6.8808594,3.840332c0,1.2797852,0,3.2001953,0.4804688,5.4399414c1.2802734,5.7602539,7.3603516,24.8007812,10.7197266,34.0810547l12.1611328,35.6811523h0.6396484c4.6396484-10.7207031,12.4804688-30.7216797,14.5605469-36.4814453c3.0400391-7.8398438,8-21.2802734,10.5595703-28.4804688c1.6005859-4.1601562,1.6005859-6.8803711,1.6005859-8.800293s-1.9199219-5.2802734-6.5605469-5.2802734h-4.9599609c-0.6396484,0-0.7998047-0.4799805-0.7998047-1.4399414V204.5419922z'
                            />
                        </>
                    );
                case 'python':
                    return (
                        <>
                            <path
                                fill='#0277BD'
                                d='M24.047,5c-1.555,0.005-2.633,0.142-3.936,0.367c-3.848,0.67-4.549,2.077-4.549,4.67V14h9v2
	H15.22h-4.35c-2.636,0-4.943,1.242-5.674,4.219c-0.826,3.417-0.863,5.557,0,9.125C5.851,32.005,7.294,34,9.931,34h3.632v-5.104
	c0-2.966,2.686-5.896,5.764-5.896h7.236c2.523,0,5-1.862,5-4.377v-8.586c0-2.439-1.759-4.263-4.218-4.672
	C27.406,5.359,25.589,4.994,24.047,5z M19.063,9c0.821,0,1.5,0.677,1.5,1.502c0,0.833-0.679,1.498-1.5,1.498
	c-0.837,0-1.5-0.664-1.5-1.498C17.563,9.68,18.226,9,19.063,9z'
                            />
                            <path
                                fill='#FFC107'
                                d='M23.078,43c1.555-0.005,2.633-0.142,3.936-0.367c3.848-0.67,4.549-2.077,4.549-4.67V34h-9
	v-2h9.343h4.35c2.636,0,4.943-1.242,5.674-4.219c0.826-3.417,0.863-5.557,0-9.125C41.274,15.995,39.831,14,37.194,14h-3.632v5.104
	c0,2.966-2.686,5.896-5.764,5.896h-7.236c-2.523,0-5,1.862-5,4.377v8.586c0,2.439,1.759,4.263,4.218,4.672
	C19.719,42.641,21.536,43.006,23.078,43z M28.063,39c-0.821,0-1.5-0.677-1.5-1.502c0-0.833,0.679-1.498,1.5-1.498
	c0.837,0,1.5,0.664,1.5,1.498C29.563,38.32,28.899,39,28.063,39z'
                            />
                        </>
                    );
                case 'linux':
                    return (
                        <>
                            <polygon
                                fill='#ECEFF1'
                                points='20.1,18.2 20.2,20.5 18.6,23.5 16.1,28.4 15.6,32.5 17.4,38.3 21.5,40.6 27.7,40.6 33.5,36.2 
	36.1,29.3 30.1,22 28.4,17.9 '
                            />
                            <path
                                fill='#263238'
                                d='M34.3,23.9c-1.6-2.3-2.9-3.7-3.6-6.6c-0.7-2.9,0.2-2.1-0.4-4.6c-0.3-1.3-0.8-2.2-1.3-2.9
	c-0.6-0.7-1.3-1.1-1.7-1.2c-0.9-0.5-3-1.3-5.6,0.1c-2.7,1.4-2.4,4.4-1.9,10.5c0,0.4-0.1,0.9-0.3,1.3c-0.4,0.9-1.1,1.7-1.7,2.4
	c-0.7,1-1.4,2-1.9,3.1c-1.2,2.3-2.3,5.2-2,6.3c0.5-0.1,6.8,9.5,6.8,9.7c0.4-0.1,2.1-0.1,3.6-0.1c2.1-0.1,3.3-0.2,5,0.2
	c0-0.3-0.1-0.6-0.1-0.9c0-0.6,0.1-1.1,0.2-1.8c0.1-0.5,0.2-1,0.3-1.6c-1,0.9-2.8,1.9-4.5,2.2c-1.5,0.3-4-0.2-5.2-1.7
	c0.1,0,0.3,0,0.4-0.1c0.3-0.1,0.6-0.2,0.7-0.4c0.3-0.5,0.1-1-0.1-1.3c-0.2-0.3-1.7-1.4-2.4-2c-0.7-0.6-1.1-0.9-1.5-1.3
	c0,0-0.6-0.6-0.8-0.8c-0.2-0.2-0.3-0.4-0.4-0.5c-0.2-0.5-0.3-1.1-0.2-1.9c0.1-1.1,0.5-2,1-3c0.2-0.4,0.7-1.2,0.7-1.2
	s-1.7,4.2-0.8,5.5c0,0,0.1-1.3,0.5-2.6c0.3-0.9,0.8-2.2,1.4-2.9s2.1-3.3,2.2-4.9c0-0.7,0.1-1.4,0.1-1.9c-0.4-0.4,6.6-1.4,7-0.3
	c0.1,0.4,1.5,4,2.3,5.9c0.4,0.9,0.9,1.7,1.2,2.7c0.3,1.1,0.5,2.6,0.5,4.1c0,0.3,0,0.8-0.1,1.3c0.2,0,4.1-4.2-0.5-7.7
	c0,0,2.8,1.3,2.9,3.9c0.1,2.1-0.8,3.8-1,4.1c0.1,0,2.1,0.9,2.2,0.9c0.4,0,1.2-0.3,1.2-0.3c0.1-0.3,0.4-1.1,0.4-1.4
	C37.6,29.9,35.9,26.2,34.3,23.9z'
                            />
                            <g>
                                <ellipse
                                    fill='#ECEFF1'
                                    cx='21.6'
                                    cy='15.3'
                                    rx='1.3'
                                    ry='2'
                                />
                                <ellipse
                                    fill='#ECEFF1'
                                    cx='26.1'
                                    cy='15.2'
                                    rx='1.7'
                                    ry='2.3'
                                />
                            </g>
                            <g>
                                <ellipse
                                    transform='matrix(-0.1254 -0.9921 0.9921 -0.1254 8.9754 38.9969)'
                                    fill='#212121'
                                    cx='21.7'
                                    cy='15.5'
                                    rx='1.2'
                                    ry='0.7'
                                />
                                <ellipse
                                    fill='#212121'
                                    cx='26'
                                    cy='15.6'
                                    rx='1'
                                    ry='1.3'
                                />
                            </g>
                            <g>
                                <path
                                    fill='#FFC107'
                                    d='M39.3,37.6c-0.4-0.2-1.1-0.5-1.7-1.4c-0.3-0.5-0.2-1.9-0.7-2.5c-0.3-0.4-0.7-0.2-0.8-0.2
		c-0.9,0.2-3,1.6-4.4,0c-0.2-0.2-0.5-0.5-1-0.5c-0.5,0-0.7,0.2-0.9,0.6s-0.2,0.7-0.2,1.7c0,0.8,0,1.7-0.1,2.4
		c-0.2,1.7-0.5,2.7-0.5,3.7c0,1.1,0.3,1.8,0.7,2.1c0.3,0.3,0.8,0.5,1.9,0.5c1.1,0,1.8-0.4,2.5-1.1c0.5-0.5,0.9-0.7,2.3-1.7
		c1.1-0.7,2.8-1.6,3.1-1.9c0.2-0.2,0.5-0.3,0.5-0.9C40,37.9,39.6,37.7,39.3,37.6z'
                                />
                                <path
                                    fill='#FFC107'
                                    d='M19.2,37.9c-1-1.6-1.1-1.9-1.8-2.9c-0.6-1-1.9-2.9-2.7-2.9c-0.6,0-0.9,0.3-1.3,0.7
		c-0.4,0.4-0.8,1.3-1.5,1.8c-0.6,0.5-2.3,0.4-2.7,1c-0.4,0.6,0.4,1.5,0.4,3c0,0.6-0.5,1-0.6,1.4c-0.1,0.5-0.2,0.8,0,1.2
		c0.4,0.6,0.9,0.8,4.3,1.5c1.8,0.4,3.5,1.4,4.6,1.5c1.1,0.1,3,0,3-2.7C21,39.9,20.1,39.5,19.2,37.9z'
                                />
                                <path
                                    fill='#FFC107'
                                    d='M21.1,19.8C20.5,19.4,20,19,20,18.4c0-0.6,0.4-0.8,1-1.3c0.1-0.1,1.2-1.1,2.3-1.1s2.4,0.7,2.9,0.9
		c0.9,0.2,1.8,0.4,1.7,1.1c-0.1,1-0.2,1.2-1.2,1.7c-0.7,0.2-2,1.3-2.9,1.3c-0.4,0-1,0-1.4-0.1C22.1,20.8,21.6,20.3,21.1,19.8z'
                                />
                            </g>
                            <g>
                                <path
                                    fill='#634703'
                                    d='M20.9,19c0.2,0.2,0.5,0.4,0.8,0.5c0.2,0.1,0.5,0.2,0.5,0.2c0.4,0,0.7,0,0.9,0c0.5,0,1.2-0.2,1.9-0.6
		c0.7-0.3,0.8-0.5,1.3-0.7c0.5-0.3,1-0.6,0.8-0.7c-0.2-0.1-0.4,0-1.1,0.4c-0.6,0.4-1.1,0.6-1.7,0.9c-0.3,0.1-0.7,0.3-1,0.3
		c-0.3,0-0.6,0-0.9,0c-0.3,0-0.5-0.1-0.8-0.2c-0.2-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.6-0.5-0.8-0.6c0,0-0.2,0-0.1,0.1
		C20.6,18.7,20.7,18.8,20.9,19z'
                                />
                                <path
                                    fill='#634703'
                                    d='M23.9,16.8c0.1,0.2,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.1,0.2,0.1c0.1-0.1,0-0.3-0.1-0.3
		C24.4,16.7,23.9,16.7,23.9,16.8z'
                                />
                                <path
                                    fill='#634703'
                                    d='M22.3,17c0,0.1,0.2,0.2,0.2,0.1c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.1-0.2-0.2-0.2
		C22.4,16.8,22.4,16.9,22.3,17z'
                                />
                            </g>
                            <path
                                fill='#455A64'
                                d='M32,34.7c0,0.1,0,0.2,0,0.3c0.2,0.4,0.7,0.5,1.1,0.5c0.6,0,1.2-0.4,1.5-0.8c0-0.1,0.1-0.2,0.2-0.3
	c0.2-0.3,0.3-0.5,0.4-0.6c0,0-0.1-0.1-0.1-0.2c-0.1-0.2-0.4-0.4-0.8-0.5c-0.3-0.1-0.8-0.2-1-0.2c-0.9-0.1-1.4,0.2-1.7,0.5
	c0,0,0.1,0,0.1,0.1c0.2,0.2,0.3,0.4,0.3,0.7C32.1,34.4,32,34.5,32,34.7z'
                            />
                        </>
                    );
                default:
                    return <path />;
            }
        };
        const SVG = ({
            name = '',
            style = {},
            fill = '#000',
            width = '100%',
            className = '',
            height = '100%',
        }) => (
            <svg
                width={width}
                style={style}
                height={height}
                viewBox={getViewBox(name)}
                className={className}
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'>
                {getPath(name, { fill })}
            </svg>
        );

        const getViewBox = name => {
            switch (name) {
                case 'react':
                    return '0 0 24 24'; // Eg. 0 0 32 32
                case 'puppeteer':
                    return '0 0 256 383';
                case 'linux':
                    return '0 2 48 48';
                case 'systemverilog':
                    return '0 -100 600 600';
                default:
                    return '0 0 48 48';
            }
        };

        // <>{content.map((section, i) => this.handleContent(section, i))}</>
        return (
            <>
                <section
                    className='software module'
                    title={title}
                    id={title}
                    data-aos='fade-up'
                    data-aos-offset='-200'
                    data-aos-delay='50'
                    data-aos-duration='1000'
                    data-aos-easing='ease-in-out'
                    data-aos-mirror='true'
                    data-aos-once='false'
                    data-aos-anchor-placement='top-center'>
                    <div className='container-skills'>
                        <Container>
                            <div className='module-header'>
                                <h2 className='module-title'>
                                    Programming Languages <span>Software</span>
                                </h2>
                                <div className='module-line'></div>
                            </div>
                            <Row>
                                {programs.map((program, i) => (
                                    <Col
                                        sm='4'
                                        key={i}
                                        data-aos='fade-up'
                                        data-aos-offset='-200'
                                        data-aos-delay='50'
                                        data-aos-duration='1000'
                                        data-aos-easing='ease-in-out'
                                        data-aos-mirror='true'
                                        data-aos-once='false'
                                        data-aos-anchor-placement='top-center'>
                                        <div className='seperate'>
                                            <SVG
                                                width={program.width}
                                                name={program.language}
                                                className='icon'
                                            />
                                            <h3 className='progName'>
                                                {program.name}
                                            </h3>
                                        </div>
                                    </Col>
                                ))}
                                <br className='clearIt' />
                            </Row>
                        </Container>
                    </div>
                    {/* <div id="particles-js"></div> */}
                    {/* <canvas id='canvas1' ref={this.canvasRef}></canvas> */}
                </section>
            </>
        );
    }
}

const mapStateToProps = (state, passed) => {
    return {
        data: state.content.software[passed.id],
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Software);
